import React from "react";
import { useClock } from "../hooks/useClock";
import VolumeBadge from "./VolumeBadge";
import SoundCheck from "./SoundCheck";

// Tijd en datum in de topbar, met het volumebalkje als dat net veranderd is en de geluidstest.
const TopbarClock = ({ soundCode = false, soundCheck = true }) => {
  const { hours, minutes, date } = useClock();

  return (
    <div className="topbar-clock">
      <span className="tc-time">
        {hours}:{minutes}
      </span>
      <span className="tc-date">{date}</span>
      <VolumeBadge />
      {soundCheck && <SoundCheck code={soundCode} />}
    </div>
  );
};

export default TopbarClock;
